import { Instance, types } from 'mobx-state-tree'
import { FlightNetworkModel } from './FlightNetworkModel'

export const DraftVersionModel = types.model('DraftVersionModel', {
    uuid: types.string,
    revision: types.number
})

const DraftEditorModel = types.model('DraftEditorModel', {
    editor_name: types.string,
    editor_email: types.string,
    start_edit_timestamp: types.string
})

export const DraftMetadataModel = types.model('DraftEditorInfoModel', {
    draft_version: types.maybeNull(DraftVersionModel),
    draft_editor: types.maybeNull(DraftEditorModel),
    is_current_user_editor: types.boolean,
})


const DraftNetworkModel = types.model('DraftNetworkModel', {
    draft_version: DraftVersionModel,
    flight_network: FlightNetworkModel
})

const DraftNetworkInfoModel = types.model('DraftNetworkInfo', {
    draft: types.maybeNull(DraftNetworkModel)
})

export type DraftVersion = Instance<typeof DraftVersionModel>
export type DraftEditor = Instance<typeof DraftEditorModel>
export type DraftMetadata = Instance<typeof DraftMetadataModel>
export type DraftNetworkInfo = Instance<typeof DraftNetworkInfoModel>